/* src/app/modules/home/pages/dashboard-v2/dashboard-v2.component.scss */
.main-page {
  padding: 5.5em 3em 0em 3em;
  width: 100%;
  box-sizing: border-box;
}
.sections-grid {
  display: flex;
  justify-content: center;
  padding: 0 8px;
}
.sections-grid-inner {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  max-width: 1490px;
}
.main-page-footer {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 8px;
}
.footer-line {
  flex: 1;
  height: 3px;
  background-color: var(--ion-color-medium, #92949c);
  opacity: 0.4;
}
.main-page-see-all-btn {
  --border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  min-width: 200px;
}
.main-page-search-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
}
.main-page-search-item {
  --background: transparent;
  --padding-start: 0;
  --min-height: 55px;
  margin: 0;
  width: 50%;
  flex-shrink: 1;
}
.main-page-favourites-btn {
  --border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  min-width: 180px;
}
@media only screen and (max-width: 1200px) {
  .main-page-search-item {
    width: 60%;
  }
}
@media only screen and (max-width: 720px) {
  .main-page-search-row {
    flex-wrap: wrap;
  }
  .main-page-search-item {
    width: 100%;
  }
  .main-page-favourites-btn {
    width: 100%;
  }
  .main-page-footer {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .footer-line {
    display: none;
  }
  .main-page-see-all-btn,
  .main-page-favourites-btn {
    width: 100%;
    min-width: 0;
    margin: 0;
  }
}
.search-results {
  display: flex;
  justify-content: center;
  margin-bottom: -10px;
}
.search-results .search-results-inner {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 1500px;
}
.search-results .search-result-card {
  flex: 0 0 auto;
}
@media only screen and (min-width: 720px) {
  .dashboard-section-title {
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 0.5em;
  }
}
@media only screen and (max-width: 720px) {
  .dashboard-section-title {
    font-size: 1.25rem;
    text-align: center;
    margin-bottom: 1em;
  }
}
.search-sections {
  margin-bottom: 12px;
}
.spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
  z-index: 999;
}
.main-page-no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
  text-align: center;
}
.main-page-no-results p {
  font-size: 1rem;
  margin: 0;
}
.main-page-no-results-icon {
  font-size: 3rem;
  margin-bottom: 12px;
  color: var(--ion-color-medium, #92949c);
}
.spinner {
  display: block;
  margin: 48px auto;
}
/*# sourceMappingURL=dashboard-v2.component-Q6MST77H.css.map */
